import { enableAutoPreviews } from '@prismicio/next';
import { Route, createClient as prismicClient } from '@prismicio/client';

// Services
import { developmentCache, productionCache } from '../configuration/cache';

type CreateClientRequest = {
  repositoryName: string;
  enablePreview?: boolean;
  routes?: (string | Route)[];
};

export const createClient = ({
  routes,
  enablePreview,
  repositoryName,
}: CreateClientRequest) => {
  const client = prismicClient(repositoryName, {
    routes: routes ?? [],
    fetchOptions:
      process.env.NODE_ENV === 'production'
        ? productionCache
        : developmentCache,
  });

  if (enablePreview) {
    enableAutoPreviews({ client: client });
  }

  return client;
};
